// src/components/card/Card.js
// Reusable Card component using Chakra UI's theme styling system

import React from "react";
import PropTypes from 'prop-types';
// Chakra Imports
import { Box, useStyleConfig } from "@chakra-ui/react";

function Card(props) {
  // Destructure props: variant for styling, children to render inside, rest for other Box props
  const { variant, children, ...rest } = props;

  // Get styles defined for "Card" in the Chakra theme, applying the specified variant
  // Note: Requires theme configuration for "Card" component styles.
  const styles = useStyleConfig("Card", { variant });

  // Render a Box component, applying the theme styles via __css prop
  // and spreading any other passed props (like padding, margin, etc.)
  return (
    <Box __css={styles} {...rest}>
      {children} {/* Render content passed inside the Card */}
    </Box>
  );
}

// Define PropTypes for the component
Card.propTypes = {
  variant: PropTypes.string, // Optional variant string to apply different styles
  children: PropTypes.node, // Any content to be rendered inside the card
};


export default Card;
